const isClipboardApiSupported = (): boolean =>
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');

export const useCopyToClipboard = (): {
	copyToClipboard: (value: string | undefined) => Promise<void>;
} => {
	const copyToClipboard = async (value: string | undefined): Promise<void> => {
		if (value && isClipboardApiSupported()) {
			// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
			await navigator.clipboard.writeText(value);
		}
	};

	return { copyToClipboard };
};
